import { signedFetch } from './client';

export interface Projection {
  streamKey: string;
  currentState: Record<string, unknown>;
  lastSequence: number;
  lastUpdated: string;
  projectionVersion: number;
  reducerType: string;
}

export async function listProjections(storeName: string, limit = 50): Promise<{ projections: Projection[]; count: number }> {
  const resp = await signedFetch('GET', `/stores/${storeName}/projections?limit=${limit}`);
  return resp.data as { projections: Projection[]; count: number };
}

export async function getStreamProjection(storeName: string, streamKey: string): Promise<Projection> {
  const resp = await signedFetch('GET', `/stores/${storeName}/streams/${encodeURIComponent(streamKey)}/projection`);
  return resp.data as Projection;
}

export async function queryProjections(storeName: string, filters: Record<string, unknown>, limit = 50): Promise<{ projections: Projection[]; count: number }> {
  const resp = await signedFetch('POST', `/stores/${storeName}/projections/query`, { filters, limit });
  return resp.data as { projections: Projection[]; count: number };
}

export interface CrossStoreResult {
  correlationKey: string;
  stores: Record<string, { currentState: Record<string, unknown>; lastSequence: number; lastUpdated: string; projectionVersion: number } | null>;
  queriedAt: string;
}

export async function crossStoreProjectionQuery(correlationKey: string, stores: string[]): Promise<CrossStoreResult> {
  const resp = await signedFetch('POST', `/query/projections`, { correlationKey, stores });
  return resp.data as CrossStoreResult;
}
